import * as XLSX from 'xlsx'
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Button, Label } from 'reactstrap';
import techbrainlogo from './techbrain2.png'
import ssfm from './SSFM2.png'
import { AlignCenter } from 'react-feather';
import { theme } from 'highcharts';
import ExcelJS from 'exceljs';
import path from 'path';
import fs from 'fs';
import { toDate } from 'date-fns';
import { useAppSelector } from '../../reduxToolkit/hooks';
import ApiService from '../../services/apiService';
import { method } from 'lodash';
import { useEffect, useState } from 'react';
import { Console } from 'console';
import lcclogo from './logo1.png'
import odhisaa from './logo3.png'


type ExportExcelProps = {
  data?: any;
  fileName: string;
  columnStyle?: any;
  unitPrice?: number|string;
  EffectiveFrom?:string // <-- optional
  selectedChakScheme?:string;
  hiddenColumns?: string[];
  columnOrder?: string[];
  fromDate?:string;
  toDate?:string;
  columnHeaderMap?: Record<string, string>; 
  style?:{}
  getData: () => Promise<any>;


};

const ExportExcel = ({ getData, fileName, columnStyle,unitPrice,EffectiveFrom,selectedChakScheme,hiddenColumns =[],columnOrder, toDate,columnHeaderMap,style }: ExportExcelProps) => {
     
    const [userName,setUserName] = useState<string>('')
    const userId = useAppSelector((state)=>state.user.userId)
    const [data, setData] = useState<any[]>([]);
   
    useEffect(() => {
      if (userId != null) {
        const fetchUserName = async () => {
          try {
            const response = await ApiService.axiosApi(`/auth/${userId}`, { method: 'GET' });
            if (response.success) {
              setUserName(response.data.userName);
            } else {
              console.log('unable to get username');
            }
          } catch (e) {
            console.log(e);
          }
        };
        fetchUserName();
      }
    }, [userId]);

    const handleExport = async (type: "excel" | "pdf") => {
      const fullData = await getData();   // ⬅ fetch all rows
      
      if (!fullData || fullData.length === 0) {
        console.error("No data to export");
        return;
      }
  
      // continue Excel export using fullData instead of props.data
      
        
      setTimeout(() => {
        if (type === "excel") exportToExcel(fullData);
        if (type === "pdf") exportToPDF(fullData);
      }, 50);
    };
    

  const exportToExcel = async(data:any) => {


    const allKeys = columnOrder ?? Object.keys(data[0]);

    // 2️⃣ Filter out hidden columns
    const visibleKeys = allKeys.filter(key => !hiddenColumns.includes(key));

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(`${fileName}`);

    // ===== Fetch Logo as ArrayBuffer =====
    const response = await fetch(techbrainlogo);
    const logoBuffer = await response.arrayBuffer();
    const imageId = workbook.addImage({
      buffer: logoBuffer,
      extension: 'png',
    });
    sheet.addImage(imageId, 'A1:B4');

    // const response2 = await fetch(lcclogo)
    // const logoBuffer2 = await response2.arrayBuffer();
    // const imageId2 = workbook.addImage({
    //   buffer: logoBuffer2,
    //   extension: 'png',
    // });
    // sheet.addImage(imageId2, 'D1:E6'); 

    // const response3 = await fetch(odhisaa)
    // const logoBuffer3 = await response3.arrayBuffer();
    // const imageId3 = workbook.addImage({
    //   buffer: logoBuffer3,
    //   extension: 'png',
    // });
    // sheet.addImage(imageId3, 'D1:E6'); 
    
    // ===== Boxed Title =====
    sheet.mergeCells('F1:H4');
    const titleCell = sheet.getCell('F1');
    titleCell.value = 'Kusumi Smart Irrigation Project';
    titleCell.font = { size: 18, bold: true };
    titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    titleCell.border = {
      top: { style: 'thick' },
      bottom: { style: 'thick' },
      left: { style: 'thick' }, 
      right: { style: 'thick' },
    };
    sheet.addRow([]);
   
    // ===== Date below title =====
    if(fileName === 'Scheme Wise Summary' || fileName === 'All Scheme Summary'){
       sheet.mergeCells('A6:C6');
      const EffectiveFromcell = sheet.getCell('A6');
      EffectiveFromcell.value =`EffectiveFrom: ${EffectiveFrom}`;
      EffectiveFromcell.font = { size: 12, italic: true };
      EffectiveFromcell.alignment = { horizontal: 'left' };

    } 
   if(( fileName == 'Chak_History' || fileName == 'Alarm_History') || (fileName == 'Power_Consumption_Report' || fileName =='Station_Volume_Report') || (fileName == 'Pumping_Station_Status_Report' || fileName == 'Pumping_Station_Volume_Report')){
  const dateRow = sheet.addRow([]).number;
  sheet.mergeCells(`B${dateRow}:C${dateRow}`);
  const fromCell = sheet.getCell(`B${dateRow}`);
  fromCell.value = `FromDate:${EffectiveFrom}`;
  fromCell.font = { size: 12, italic: true };
  fromCell.alignment = { horizontal: 'left' };

  sheet.mergeCells(`E${dateRow}:F${dateRow}`);
  const toCell = sheet.getCell(`E${dateRow}`);
  toCell.value = `ToDate: ${toDate}`;
  toCell.font = { size: 12, italic: true };
  toCell.alignment = { horizontal: 'right' };
}
 /**/

 




 if (userName) {
  const userRowNum = sheet.addRow([]).number; // empty row before username
  sheet.mergeCells(`B${userRowNum}:D${userRowNum}`); // adjust end col as needed
  const userCell = sheet.getCell(`B${userRowNum}`);
  userCell.value = `Generated by: ${userName}`;
  userCell.font = { size: 12, italic: true };
  userCell.alignment = { horizontal: 'left' };
  sheet.addRow([]); // optional blank row after
}
   
if((fileName == 'Dms_History' || fileName == 'Roms_History')||(fileName =='Chak_History'|| fileName == 'Alarm_History')){
  const userRowNum = sheet.addRow([]).number;
  sheet.mergeCells(`B${userRowNum}:D${userRowNum}`);
  const parentChak = sheet.getCell(`B${userRowNum}`);
  parentChak.value = `Chak Name: ${selectedChakScheme}`;
  parentChak.font = { size: 12, italic: true };
  parentChak.alignment = { horizontal: 'left' };
  // optional blank row after
}

if(fileName == 'Dms_History'){
  const userRowNum = sheet.addRow([]).number;
  sheet.mergeCells(`B${userRowNum}:D${userRowNum}`);
  const parentChak = sheet.getCell(`B${userRowNum}`);
  parentChak.value = `Parent Chak: ${data[0].parentChak}`;
  parentChak.font = { size: 12, italic: true };
  parentChak.alignment = { horizontal: 'left' };
  // optional blank row after
}

if(fileName == 'Dms_History' || fileName == 'Roms_History'){
  const userRowNum = sheet.addRow([]).number;
  sheet.mergeCells(`B${userRowNum}:D${userRowNum}`);
  const parentChak = sheet.getCell(`B${userRowNum}`);
  parentChak.value = `Scheme/Village: ${data[0].schemeVillage}`;
  parentChak.font = { size: 12, italic: true };
  parentChak.alignment = { horizontal: 'left' };
  sheet.addRow([]); // optional blank row after
}



    // ===== Leave a blank row before table =====
    sheet.addRow([]);

    // ===== Table Headers =====
    const headerLabels = columnHeaderMap
    ? visibleKeys.map(key => columnHeaderMap[key] ?? key)
    : visibleKeys; // ✅ fallback to data keys
    const headerRow = sheet.addRow(['', 'Serial No.', ...headerLabels]);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center' };
    headerRow.eachCell((cell:any,colNumber:any) => {
      if (colNumber > 1) {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9D9D9' } };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
    });

    // ===== Table Data Rows with alternating colors =====
    data.forEach((item:any, index:any) => {
        const rowData = ['', index + 1, ...visibleKeys.map(key => item[key])]; // only visible columns
      const row = sheet.addRow(rowData);
      row.eachCell((cell:any, colNumber:any) => {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        };
        cell.alignment = { horizontal: 'center' };
        if (index % 2 === 0 && colNumber > 1) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2F2F2' } };
        }
      });
    });

    // ===== Footer Summary =====
    

    // ===== Adjust Column Widths =====
    sheet.columns.forEach((col:any) => {
      col.width = 15;
    });
    sheet.addRow([])

    const footerRowNum = sheet.addRow([]).number;
  sheet.mergeCells(`A${footerRowNum}:B${footerRowNum}`);
  const footerCell = sheet.getCell(`A${footerRowNum}`);
  footerCell.value = `Generated On: ${new Date().toLocaleDateString()}`;
  footerCell.font = { size: 12, italic: true };
  footerCell.alignment = { horizontal: 'right' };
    // ===== Add outer border around entire report =====
    const lastRow = sheet.lastRow?.number || 1;

// last column (assuming your data object keys give columns)
const lastCol = allKeys.length + 3; // +2 for logo/title columns

// Apply border dynamically around entire content
for (let r = 1; r <= lastRow; r++) {
  const row = sheet.getRow(r);
  for (let c = 1; c <= lastCol + 2; c++) {
    const cell = row.getCell(c);
    // preserve existing borders and add outer thin border
    cell.border = {
      top: cell.border?.top || { style: 'thin' },
      bottom: cell.border?.bottom || { style: 'thin' },
      left: cell.border?.left || { style: 'thin' },
      right: cell.border?.right || { style: 'thin' },
    };
  }
}


    // ===== Export Excel =====
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}`;
    a.click();
    URL.revokeObjectURL(url);
  };


  const exportToPDF = (data:any) => {                     
    const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    const marginTop = 20;
    const imgWidth = 100;
    const imgHeight = 44;
    const img1Width = 32;
    const img1Height = 50;
    const gap = 40;
  
    
  
    // 3️⃣ Prepare table
    const allKeys = columnOrder ?? Object.keys(data[0]);
    const headers = allKeys.filter(key => !hiddenColumns.includes(key));
    const body = data.map((row: any, index: number) => [
      index + 1, // add Serial No.
      ...headers.map((key) => row[key]),
    ]);
       
    const addHeader = () => {
      doc.setFont("times", "bold");
      doc.setFontSize(22);
      doc.text("Shivnala Lift Irrigation Project", margin, margin);
      
      if(fileName !== 'Wua_Water_Distribution_Report') {
      doc.setFont("times", "normal");
      doc.setFontSize(12);
      doc.text(`${(fileName === 'All Scheme Summary' || fileName === 'Scheme Wise Summary')
        ? 'Scheme'
        : ((fileName === 'Roms_History'||fileName=='Chak_History') ? 'ChakName' : 'ChakName')}: ${selectedChakScheme}`, margin, margin + 30);
      }
      if(fileName == 'Roms_History' || fileName =='Dms_History'){
        doc.text(`Scheme/Village: ${data[0].schemeVillage}`, margin, margin + 45)
     }
       
      if(fileName == 'Dms_History'){
        doc.text(`ParentChak: ${data[0].parentChak}`, margin, margin + 60)
      }

      
     
        if (userName) {
          doc.setFontSize(12);
          doc.text(`Generated by: ${userName}`, margin, margin + 75);
        }
    
        doc.text(`Generated on: ${new Date().toLocaleString()}`, margin + 570, margin + 75);

      doc.addImage(ssfm, "PNG", pageWidth - img1Width - margin, marginTop, img1Width, img1Height);
      doc.addImage(techbrainlogo, "PNG", pageWidth - imgWidth - gap - margin, marginTop, imgWidth, imgHeight);
    };
  
    // 3️⃣ Dynamic column splitting based on page width
    const usableWidth = pageWidth - margin * 2;
    let startIndex = 0; 
while (startIndex < headers.length) {
  // Decide how many columns to fit on this page
  // Try max columns that can fit based on default min width
  let endIndex = startIndex;
  let maxCols = headers.length - startIndex;
  
  // For simplicity, we just cap max columns per page
  const maxColsPerPage = 9; // adjust as needed
   endIndex = startIndex + Math.min(maxColsPerPage, headers.length - startIndex);
  const currentHeaders = ["Sr No", ...headers.slice(startIndex, endIndex)];
  const currentBody = body.map((row: any) => [row[0], ...row.slice(startIndex + 1, endIndex + 1)]);

  // Calculate **even width for each column** on this page
  const colWidth = usableWidth / currentHeaders.length;
  const columnStyles: any = {};
  currentHeaders.forEach((_, i) => {
    columnStyles[i] = { cellWidth: colWidth, halign: "center" };
  });

  if (startIndex > 0) doc.addPage();
  addHeader();

  autoTable(doc, {
    head: [currentHeaders],
    body: currentBody,
    startY: margin + 90,
    tableWidth: 'auto', // use auto + columnStyles
    theme: 'grid',
    headStyles: { halign: 'center', cellPadding: 4 },
    styles: { fontSize: 10, cellPadding: 3, overflow: 'linebreak' },
    columnStyles,
  });

  startIndex = endIndex;
} 
  
    // 5️⃣ Place labels below table
    const finalY = (doc as any).lastAutoTable?.finalY || margin + 60; // fallback if table empty
    const labelY = finalY + 20;
  
    doc.setFont("times", "normal");
    doc.setFontSize(12);
    doc.text(`${(fileName === 'All Scheme Summary' || fileName === 'Scheme Wise Summary')
      ? 'EffectiveFrom'
      : (fileName === 'Chak' ? 'FromDate' : 'FromDate')}: ${EffectiveFrom}`, margin, labelY);
    
   
    doc.text(`${(fileName === 'All Scheme Summary' || fileName === 'Scheme Wise Summary')
      ? 'Unit Price'
      : (fileName === 'Chak' ? 'Todate' : 'Todate')}: ${(fileName === 'All Scheme Summary' || fileName === 'Scheme Wise Summary')?unitPrice: toDate}`, margin + 620, labelY);

    // 7️⃣ Save PDF
    doc.save(`${fileName}.pdf`);
};

return (
  <>

    <div className='d-flex flex-column ' style={style}>
      <Label style={{visibility:'hidden'}}>Generated</Label>
      <Button color='primary'  className=' px-1 ' onClick={() => handleExport("excel")}  style={{
                 width:'100%', whiteSpace: 'nowrap',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis' ,
                 
              }}>Export Excel</Button>
      {/* <Button  onClick={() => handleExport("pdf")}>Export Pdf</Button> */}
    </div>

  </>
)
}

export default ExportExcel;
